import { ChevronDownIcon, UserIcon } from "@heroicons/react/24/outline"
import { Link } from "react-router-dom"
import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  Logo,
} from "@/components/Primitives"
import { Button } from "@/components/Primitives/Button"
import { useConfig } from "@/hooks/useConfig"
import { logout } from "@/lib/api/auth"
import { removeApiToken } from "@/lib/api/client"
import {
  clearLocalStorageToken,
  isAuthenticated,
} from "@/hooks/useLocalStorage"
import posthog from "posthog-js"

function AccountDropdown() {
  const { t } = useConfig()

  return (
    <div className="bg-neutral-100 rounded-full cursor-pointer">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center space-x-2 hover:bg-accent hover:text-accent-foreground rounded-md px-1 py-1 text-sm font-medium hover:rounded-full cursor-pointer">
          <Avatar>
            <AvatarFallback>
              <Icon icon={UserIcon} size="sm" variant="secondary" />
            </AvatarFallback>
          </Avatar>
          <Icon
            icon={ChevronDownIcon}
            size="sm"
            variant="muted"
            className="stroke-3"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem>
            <Link to="/profile" className="w-full">
              {t("config_nav_profile")}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="text-destructive">
            <Link
              data-testid="logout"
              to="/login"
              onClick={async () => {
                await logout()
                clearLocalStorageToken()
                removeApiToken()
                posthog.reset()
              }}
              className="w-full"
            >
              {t("config_logout_button")}
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

function SignUpButton() {
  const { t } = useConfig()

  return (
    <Button asChild>
      <Link to="/signup">{t("config_navigation_button_signup")}</Link>
    </Button>
  )
}

export function NavigationBar() {
  const userIsAuthenticated = isAuthenticated()

  return (
    <nav className="border-b bg-background">
      <div className="flex h-14 items-center px-4 py-2 container mx-auto">
        <Link to="/quests" className="flex items-center space-x-2">
          <Logo variant="color" />
        </Link>
        <div className="ml-auto flex items-center space-x-4">
          {userIsAuthenticated ? <AccountDropdown /> : <SignUpButton />}
        </div>
      </div>
    </nav>
  )
}
